import Writing from '@assets/icons/writing.svg'
import { Icon } from './Icon'

export const WritingIcon = Icon(Writing)
